<template>
  <div class="container"  :style="'height:'+containerHeight+'px'">
    <iframe :src="url"
            v-if="url"
            class="iframe" ref="iframe" allowfullscreen></iframe>
  </div>
</template>

<script>
import { thirdVideoIndex } from "../../assets/api/api";
export default {
  data () {
    return {
      goodsId: '',
      subId: '',
      url: '',
      containerHeight: 0
    }
  },
  mounted () {
    this.subId = this.$route.query.subId
    this.goodsId = this.$route.query.goodsId
     this.containerHeight = document.documentElement.clientHeight - 80
    this.init()
    if(this.$route.query.iframeUrl) {
      this.url = this.$route.query.iframeUrl
    }else {
      this.fetchData()
    }
  },
  methods: {
    fetchData () {
      const params = {
        subId: this.subId,
        goodsId: this.goodsId,
        uId: localStorage.getItem('userId'),
      }
        thirdVideoIndex(params).then(res => {
          this.url = res
      }).catch((err) => {
      }).finally(() => {
      })
    },
    init () {
      window.addEventListener("message", this.handleMessage);
    },
    //获取iframe传过来的信息
    handleMessage(event){
      //event为传过来的信息
      console.log(event)
      console.log('event为传过来的信息')
    }
  }
}
</script>

<style scoped lang="scss">
.container {
  width: 100%;
  position: relative;
  justify-content: center;
  background-color: #ffffff;
  .iframe {
    // padding: 20px 20px 0;
    // -webkit-box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.14);
    // box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.14);
    width: 100%;
    // margin-top: 30px;
    // margin-bottom: 30px;
    // border-radius: 10px;
    // height: auto;
     border: 0;
  }
}
</style>
